// extracted by mini-css-extract-plugin
module.exports = {"container":"viewStand_container__3gSqq","containerLoading":"viewStand_containerLoading__27cgr","bgimg":"viewStand_bgimg__1dpZ5","img":"viewStand_img__Yz6jG"};